"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRestoredRows = exports.setFailedRows = exports.setBcfParserProcessResult = exports.setBcfParserProcessErrorResult = exports.setBcfImportSuccess = exports.setBcfImportJobId = exports.resetBcfImport = exports.reducer = exports.initialState = exports.getRestoredRows = exports.getFailedRows = exports.getBcfParserProcessResult = exports.getBcfParserProcessErrorResult = exports.getBcfImportSuccess = exports.getBcfImportState = exports.getBcfImportJobId = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _issuesCollection = require("./issuesCollection");
const initialState = exports.initialState = {
  bcfParserProcessResult: null,
  bcfParserProcessErrorResult: null,
  restoredRows: {},
  failedRows: {},
  bcfImportSuccess: {},
  importJobId: ""
};
const bcfImportSlice = (0, _toolkit.createSlice)({
  name: "bcfImport",
  initialState,
  reducers: {
    setBcfParserProcessResult: (state, action) => {
      var _action$payload;
      state.bcfParserProcessResult = (_action$payload = action.payload) !== null && _action$payload !== void 0 ? _action$payload : state.bcfParserProcessResult;
    },
    setBcfParserProcessErrorResult: (state, action) => {
      var _action$payload2;
      state.bcfParserProcessErrorResult = (_action$payload2 = action.payload) !== null && _action$payload2 !== void 0 ? _action$payload2 : state.bcfParserProcessErrorResult;
    },
    setRestoredRows: (state, action) => {
      state.restoredRows = {
        ...state.restoredRows,
        ...action.payload
      };
    },
    setFailedRows: (state, action) => {
      state.failedRows = {
        ...state.failedRows,
        ...action.payload
      };
    },
    resetBcfImport: () => initialState,
    // New reducer
    setBcfImportSuccess: (state, action) => {
      state.bcfImportSuccess = {
        ...state.bcfImportSuccess,
        ...action.payload
      };
    },
    setBcfImportJobId: (state, action) => {
      state.importJobId = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(_issuesCollection.issuesRestoreEnd, (state, action) => {
      const {
        issueIds: [issueId]
      } = action.payload;
      if (state.bcfParserProcessErrorResult) {
        var _state$bcfParserProce;
        const issue = state.bcfParserProcessErrorResult.issues[issueId];
        issue.errors = []; // Change errors to an empty array
        issue.issueFromBcf.existing = true;
        if ((_state$bcfParserProce = state.bcfParserProcessResult) !== null && _state$bcfParserProce !== void 0 && _state$bcfParserProce.issues) {
          state.bcfParserProcessResult.issues[issueId] = issue;
        }
      }
    });
  }
});
const {
  setBcfParserProcessResult,
  setBcfParserProcessErrorResult,
  setRestoredRows,
  setFailedRows,
  resetBcfImport,
  setBcfImportSuccess,
  setBcfImportJobId
} = bcfImportSlice.actions;
exports.setBcfImportJobId = setBcfImportJobId;
exports.setBcfImportSuccess = setBcfImportSuccess;
exports.resetBcfImport = resetBcfImport;
exports.setFailedRows = setFailedRows;
exports.setRestoredRows = setRestoredRows;
exports.setBcfParserProcessErrorResult = setBcfParserProcessErrorResult;
exports.setBcfParserProcessResult = setBcfParserProcessResult;
const reducer = exports.reducer = bcfImportSlice.reducer;
const STATE_KEY = exports.STATE_KEY = bcfImportSlice.name;
const getBcfImportState = state => state[STATE_KEY];
exports.getBcfImportState = getBcfImportState;
const getBcfParserProcessResult = state => getBcfImportState(state).bcfParserProcessResult;
exports.getBcfParserProcessResult = getBcfParserProcessResult;
const getRestoredRows = state => getBcfImportState(state).restoredRows;
exports.getRestoredRows = getRestoredRows;
const getFailedRows = state => getBcfImportState(state).failedRows;
exports.getFailedRows = getFailedRows;
const getBcfParserProcessErrorResult = state => getBcfImportState(state).bcfParserProcessErrorResult;
exports.getBcfParserProcessErrorResult = getBcfParserProcessErrorResult;
const getBcfImportSuccess = state => getBcfImportState(state).bcfImportSuccess;
exports.getBcfImportSuccess = getBcfImportSuccess;
const getBcfImportJobId = state => getBcfImportState(state).importJobId;
exports.getBcfImportJobId = getBcfImportJobId;
//# sourceMappingURL=bcfImportCollection.js.map